import { UniversalTabs } from "@/shared/ui/UniversalTabs";

interface PlanTabsBlockProps {
    tabs: { label: string; value: string }[];
    activeTab: string;
    onTabChange: (tab: string) => void;
}

export const PlanTabsBlock = ({
    tabs,
    activeTab,
    onTabChange,
}: PlanTabsBlockProps) => (
    <UniversalTabs tabs={tabs} value={activeTab} onChange={onTabChange} />
);
